import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { useSettingsContext } from 'src/components/settings';
import Scrollbar from 'src/components/scrollbar';
import { useSelector } from 'react-redux';
import { HEADER, NAV } from '../config-layout';

// ----------------------------------------------------------------------

export default function Main({ children, sx, ...other }) {
  const settings = useSettingsContext();
  const drawerWidth = useSelector((state) => state.drawer.drawerWidth);

  const lgUp = useResponsive('up', 'lg');

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = drawerWidth < 110;

  const contentSpacing = isNavHorizontal
    ? {
        pb: 10,
        ...(lgUp && {
          pb: 15,
        }),
      }
    : {
        pb: 3,
        ...(lgUp && {
          px: 5,
          pb: 5,
        }),
      };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 0,
        height: '100%',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
        overflow: 'hidden',
        pt: isNavHorizontal
          ? {
              xs: `${HEADER.H_MOBILE + 24}px`,
              lg: `${HEADER.H_MOBILE * 2 + 40}px`,
            }
          : {
              xs: `${HEADER.H_MOBILE + 8}px`,
              lg: `${HEADER.H_DESKTOP + 8}px`,
            },
        ...(lgUp && {
          ...(!isNavHorizontal && {
            width: `calc(100% - ${isNavMini ? NAV.W_MINI : NAV.W_VERTICAL}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      <Scrollbar
        sx={{
          flex: '1 1 auto',
          minHeight: 0,
          height: 1,
          '& .simplebar-content-wrapper': {
            height: '100%',
          },
        }}
      >
        <Box
          sx={{
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            ...contentSpacing,
          }}
        >
          {children}
        </Box>
      </Scrollbar>
    </Box>
  );
}

Main.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
